// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* components/KdsSettingsModal/KdsSettingsModal.css */
.kds-settings-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.3);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  z-index: 11000;
  backdrop-filter: blur(2px);
}

.kds-settings-modal {
  background: white;
  width: 82vw;
  max-width: 920px;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.22);
  border-left: 1px solid rgba(226, 232, 240, 0.8);
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.kds-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
}

.kds-settings-header h2 {
  font-size: calc(18px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #0f172a;
  margin: 0;
}

.kds-settings-close {
  background: transparent;
  border: none;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: all 0.2s ease;
}

.kds-settings-close svg {
  width: 16px;
  height: 16px;
}

.kds-settings-close:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

/* RMS Notice Banner */
.kds-settings-notice {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background: #eef5ff;
  border: 1px solid #bfd7ff;
  border-radius: 14px;
}

.kds-settings-notice-icon {
  width: 16px;
  height: 16px;
  color: #2a71ff;
  flex-shrink: 0;
  margin-top: 2px;
}

.kds-settings-notice-content {
  flex: 1;
}

.kds-settings-notice-content strong {
  display: block;
  color: #1e293b;
  font-size: calc(13px + var(--kds-font-delta, 0px));
  font-weight: 600;
  margin-bottom: 4px;
}

.kds-settings-notice-content p {
  margin: 0;
  color: #64748b;
  font-size: calc(12px + var(--kds-font-delta, 0px));
  line-height: 1.4;
}

.kds-settings-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* Custom Scrollbar Styling */
.kds-settings-content::-webkit-scrollbar {
  width: 6px;
}

.kds-settings-content::-webkit-scrollbar-track {
  background: transparent;
}

.kds-settings-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
  transition: background 0.2s ease;
}

.kds-settings-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Firefox scrollbar support */
.kds-settings-content {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}


/* Section Dividers */
.kds-settings-section {
  position: relative;
}

.kds-settings-section + .kds-settings-section::before {
  content: "";
  position: absolute;
  top: -16px;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #e2e8f0;
}

.kds-settings-section h3 {
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  color: #0f172a;
  margin: 0 0 16px 0;
}

.kds-settings-subtitle {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #334155;
  margin: 0 0 12px 0;
  font-weight: 400;
}

/* Display Grid for Screen Settings */
.kds-settings-display-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.kds-settings-display-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
}

.kds-settings-display-label {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #334155;
  font-weight: 400;
}

/* Status Badges */
.kds-settings-status {
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: calc(11px + var(--kds-font-delta, 0px));
  font-weight: 600;
  text-transform: uppercase;
}

.kds-settings-status.enabled {
  background: #ecfdf5;
  color: #059669;
}

.kds-settings-status.disabled {
  background: #fff1f2;
  color: #f43f5e;
}

/* Info Rows */
.kds-settings-info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
}

.kds-settings-info-label {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #334155;
}

.kds-settings-info-value {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #334155;
  font-weight: 500;
}

/* Split Layout */
.kds-settings-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.kds-settings-column {
  display: flex;
  flex-direction: column;
}

/* Actions List */
.kds-settings-actions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.kds-settings-action-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: white;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
}

.kds-settings-action-label {
  font-size: calc(13px + var(--kds-font-delta, 0px));
  color: #334155;
}

.kds-settings-note {
  font-size: calc(11px + var(--kds-font-delta, 0px));
  color: #94a3b8;
  margin-top: 16px;
  font-style: italic;
}

.kds-settings-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
}

.kds-settings-btn-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  border-radius: 14px;
  font-size: calc(14px + var(--kds-font-delta, 0px));
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  background: #2a71ff;
  border: none;
  color: white;
}

.kds-settings-btn-close:hover {
  background: #1f63ea;
}

/* Responsive */
@media (max-width: 968px) {
  .kds-settings-modal {
    width: 90vw;
  }

  .kds-settings-split {
    grid-template-columns: 1fr;
  }

  .kds-settings-display-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 640px) {
  .kds-settings-modal {
    width: 100vw;
    border-radius: 0;
  }

  .kds-settings-header h2 {
    font-size: calc(16px + var(--kds-font-delta, 0px));
  }

  .kds-settings-notice {
    margin: 16px;
  }

  .kds-settings-content {
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/KDS/components/KdsSettingsModal/KdsSettingsModal.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8CAA8C;EAC9C,+CAA+C;EAC/C,4BAA4B;EAC5B,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;;AAGA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,kDAAkD;EAClD,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* components/KdsSettingsModal/KdsSettingsModal.css */\n.kds-settings-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.3);\n  display: flex;\n  justify-content: flex-end;\n  align-items: stretch;\n  z-index: 11000;\n  backdrop-filter: blur(2px);\n}\n\n.kds-settings-modal {\n  background: white;\n  width: 82vw;\n  max-width: 920px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.22);\n  border-left: 1px solid rgba(226, 232, 240, 0.8);\n  border-top-left-radius: 24px;\n  border-bottom-left-radius: 24px;\n  animation: slideInRight 0.3s ease-out;\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.kds-settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.kds-settings-header h2 {\n  font-size: calc(18px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #0f172a;\n  margin: 0;\n}\n\n.kds-settings-close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.kds-settings-close svg {\n  width: 16px;\n  height: 16px;\n}\n\n.kds-settings-close:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n/* RMS Notice Banner */\n.kds-settings-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  background: #eef5ff;\n  border: 1px solid #bfd7ff;\n  border-radius: 14px;\n}\n\n.kds-settings-notice-icon {\n  width: 16px;\n  height: 16px;\n  color: #2a71ff;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.kds-settings-notice-content {\n  flex: 1;\n}\n\n.kds-settings-notice-content strong {\n  display: block;\n  color: #1e293b;\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.kds-settings-notice-content p {\n  margin: 0;\n  color: #64748b;\n  font-size: calc(12px + var(--kds-font-delta, 0px));\n  line-height: 1.4;\n}\n\n.kds-settings-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n/* Custom Scrollbar Styling */\n.kds-settings-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.kds-settings-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.kds-settings-content::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 10px;\n  transition: background 0.2s ease;\n}\n\n.kds-settings-content::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Firefox scrollbar support */\n.kds-settings-content {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n\n/* Section Dividers */\n.kds-settings-section {\n  position: relative;\n}\n\n.kds-settings-section + .kds-settings-section::before {\n  content: \"\";\n  position: absolute;\n  top: -16px;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #e2e8f0;\n}\n\n.kds-settings-section h3 {\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  color: #0f172a;\n  margin: 0 0 16px 0;\n}\n\n.kds-settings-subtitle {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #334155;\n  margin: 0 0 12px 0;\n  font-weight: 400;\n}\n\n/* Display Grid for Screen Settings */\n.kds-settings-display-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.kds-settings-display-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: white;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n}\n\n.kds-settings-display-label {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #334155;\n  font-weight: 400;\n}\n\n/* Status Badges */\n.kds-settings-status {\n  display: inline-flex;\n  padding: 4px 12px;\n  border-radius: 9999px;\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.kds-settings-status.enabled {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.kds-settings-status.disabled {\n  background: #fff1f2;\n  color: #f43f5e;\n}\n\n/* Info Rows */\n.kds-settings-info-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.kds-settings-info-label {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #334155;\n}\n\n.kds-settings-info-value {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #334155;\n  font-weight: 500;\n}\n\n/* Split Layout */\n.kds-settings-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n\n.kds-settings-column {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Actions List */\n.kds-settings-actions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.kds-settings-action-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: white;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n}\n\n.kds-settings-action-label {\n  font-size: calc(13px + var(--kds-font-delta, 0px));\n  color: #334155;\n}\n\n.kds-settings-note {\n  font-size: calc(11px + var(--kds-font-delta, 0px));\n  color: #94a3b8;\n  margin-top: 16px;\n  font-style: italic;\n}\n\n.kds-settings-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.kds-settings-btn-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 0 20px;\n  border-radius: 14px;\n  font-size: calc(14px + var(--kds-font-delta, 0px));\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  background: #2a71ff;\n  border: none;\n  color: white;\n}\n\n.kds-settings-btn-close:hover {\n  background: #1f63ea;\n}\n\n/* Responsive */\n@media (max-width: 968px) {\n  .kds-settings-modal {\n    width: 90vw;\n  }\n\n  .kds-settings-split {\n    grid-template-columns: 1fr;\n  }\n\n  .kds-settings-display-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .kds-settings-modal {\n    width: 100vw;\n    border-radius: 0;\n  }\n\n  .kds-settings-header h2 {\n    font-size: calc(16px + var(--kds-font-delta, 0px));\n  }\n\n  .kds-settings-notice {\n    margin: 16px;\n  }\n\n  .kds-settings-content {\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
